import { Formik } from 'formik'

import { useAccount, useUpdateAccountJourneySettings } from 'src/hooks'
import { SwitchListComponent } from './switch-list-component'
import { IUpdateAccountJourneySettingsDto } from 'src/types'

interface IProps {
  mobile?: boolean
}

export const JourneyPageSettingsForm = ({ mobile }: IProps) => {
  const { mutateAsync: updateJourneySettings } = useUpdateAccountJourneySettings()
  const { data: account } = useAccount()

  const handleSubmit = async (values: IUpdateAccountJourneySettingsDto) => {
    await updateJourneySettings(values)
  }

  if (!account) return null

  return (
    <Formik
      initialValues={{
        hide_name: account.hide_name,
        hide_product_name: account.hide_product_name,
        map_satellite_view: account.map_satellite_view,
        show_unsgd_home_page: account.show_unsgd_home_page,
        show_unsgd_impacts_page: account.show_unsgd_impacts_page,
        show_wallet_address: account.show_wallet_address,
        show_bc_info: account.show_bc_info,
        default_landing_page: account.default_landing_page,
      }}
      onSubmit={handleSubmit}
    >
      <SwitchListComponent mobile={mobile} handleSubmit={handleSubmit} />
    </Formik>
  )
}
